import { render, staticRenderFns } from "./BesarPenyakitRanap.vue?vue&type=template&id=41610ff0"
import script from "./BesarPenyakitRanap.vue?vue&type=script&lang=js"
export * from "./BesarPenyakitRanap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41610ff0')) {
      api.createRecord('41610ff0', component.options)
    } else {
      api.reload('41610ff0', component.options)
    }
    module.hot.accept("./BesarPenyakitRanap.vue?vue&type=template&id=41610ff0", function () {
      api.rerender('41610ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/mordibilitas-ranap/BesarPenyakitRanap.vue"
export default component.exports